import React from "react";
import styled from "styled-components";

const PointWrapper = styled.div`
    display: flex;
    align-items: center;
   
    svg{
       margin-right: 20px;
    }
    .dot{
        display: block;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background: #DE443D;
      
        padding: 0;
    }
    p{
      flex: 1;
      font-weight: bold;
      color: #515151;
    }
`

const Wrapper = styled.div`
    p{
      font-weight: bold;
       color: #515151;
    }
`

const MainWrapper = styled.div`
    display: flex;
    min-height: 50vw;
    padding: 40px 0;
    align-items: center;
     @media only screen and (max-width: 600px) {
      flex-direction: column;
    }
    .imageWrapper{
      width: 40%;
      @media only screen and (max-width: 600px) {
        display: none;
        width: 50%;
      }
      padding: 2vw 4vw;
    }
    div{
      width: 40%;
      @media only screen and (max-width: 600px) {
        width: 90%;
        h2{
         text-align: center ;
        }
        p{
         text-align: justify ;
        }
      }
    }
    
`
const ImageWrapper = styled.div`
  position: relative;
  img{
      position: absolute;
      width: 55vw;
      right: 0;
      top: -19vw;
  }
`


const HowBlock = () => (
    <MainWrapper>
        <ImageWrapper className={'imageWrapper'}>
            <img src={'/block-3.jpg'}/>
        </ImageWrapper>
        <Wrapper>
            <h2>КАК ВЫРАЗИТЬ ПРОТЕСТ?</h2>
            <p>Объединяйтесь – дворами, трудовыми коллективами.</p>
            <p>Демонстрируйте протест – плакаты, собрания, цепи солидароности, марши на улице или предприятии.</p>
            <p>Эта власть стала нашей общей проблемой, которая нас сплотила. Как только требования народа будут выполнены, мы запустим страну и непременно сделаем ее гораздо лучше.</p>
        </Wrapper>
    </MainWrapper>
)

export default HowBlock;
